// Module
var code = " <gb-button icon=\"file_upload\" name=\"imageSelect\" ngf-select ngf-drop ngf-change=\"$ctrl.handleFileUpload()\" ng-model=\"$ctrl.imageToUpload\" md-colors=\"{'background-color': 'default-background-100'}\"> <span translate=\"ADD_IMAGE_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-image-widget widget=\"$ctrl.widget\"></gb-edit-image-widget> ";
// Exports
export default code;